import React from 'react';
import theme from '../theme';

function IconHeart({ filled, size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={filled ? theme.colors.error : 'none'} stroke={filled ? theme.colors.error : '#999'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/>
    </svg>
  );
}

function FavoriteButton({ isFavorite, onToggle, size = 18 }) {
  return (
    <button
      onClick={(e) => { e.stopPropagation(); onToggle(); }}
      style={{
        background: 'rgba(255,255,255,0.9)', border: 'none', borderRadius: theme.radius.circle,
        width: size + 16, height: size + 16,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer', flexShrink: 0, boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
      }}
      aria-label={isFavorite ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti'}
    >
      <IconHeart filled={isFavorite} size={size} />
    </button>
  );
}

export default FavoriteButton;